const form = document.querySelector('[data-book-form]');

if (form) {
    initBookForm(form);
}

function initBookForm(form) {
    const alert = form.querySelector('[data-book-alert]');
    const alertList = form.querySelector('[data-book-alert-list]');
    const billing = form.querySelector('[data-book-billing]');
    const terms = form.querySelector('[data-book-terms]');
    const submit = form.querySelector('[data-book-submit]');
    const billingRequired = ['postcode', 'address1', 'city'];

    form.noValidate = true;

    // Same surname: every other passenger copies the lead surname and is read-only.
    const leadSurname = form.querySelector('[data-book-first-surname]');
    const otherSurnames = [...form.querySelectorAll('[data-book-surname]')];
    const syncSurnames = () => {
        const same = checkedValue('use_same_surname') === '1';
        otherSurnames.forEach((input) => {
            input.readOnly = same;
            if (same && leadSurname) {
                input.value = leadSurname.value;
                clearError(input);
            }
        });
    };

    // Customer travelling: the contact name follows the lead passenger and is read-only.
    const leadTitle = form.querySelector('[data-book-first-title]');
    const leadFirstName = form.querySelector('[data-book-first-name]');
    const contactTitle = form.querySelector('[data-book-contact-title]');
    const contactFirstName = form.querySelector('[data-book-contact-first-name]');
    const contactLastName = form.querySelector('[data-book-contact-last-name]');
    const syncContact = () => {
        const travelling = checkedValue('customer_travelling') === '1';
        [contactFirstName, contactLastName].forEach((input) => {
            if (input) {
                input.readOnly = travelling;
            }
        });
        if (!travelling) {
            return;
        }
        if (contactTitle && leadTitle) {
            contactTitle.value = leadTitle.value;
        }
        if (contactFirstName && leadFirstName) {
            contactFirstName.value = leadFirstName.value;
        }
        if (contactLastName && leadSurname) {
            contactLastName.value = leadSurname.value;
        }
        [contactTitle, contactFirstName, contactLastName].forEach((input) => input?.value && clearError(input));
    };

    const syncBilling = () => {
        if (!billing) {
            return;
        }
        const same = checkedValue('contact[billing_address_same]') !== '0';
        billing.hidden = same;
        billingRequired.forEach((name) => {
            const input = billing.querySelector(`[data-book-address-field="${name}"]`);
            if (input) {
                input.required = !same;
                if (same) {
                    clearError(input);
                }
            }
        });
    };

    const amount = form.querySelector('[data-book-amount]');
    const payNow = form.querySelector('[data-book-pay-now]');
    const balance = form.querySelector('[data-book-balance]');
    const syncPayment = () => {
        const selected = form.querySelector('[data-book-payment]:checked');
        if (!selected) {
            return;
        }
        amount.value = selected.dataset.amount;
        payNow.textContent = selected.dataset.price;
        balance.textContent = selected.dataset.balance;
    };

    // The submit button looks disabled until every required field is valid, but stays clickable so validation can explain why.
    const syncSubmit = () => {
        if (!submit) {
            return;
        }
        if (isComplete()) {
            submit.removeAttribute('aria-disabled');
        } else {
            submit.setAttribute('aria-disabled', 'true');
        }
    };

    form.addEventListener('change', (event) => {
        const target = event.target;
        if (target.name === 'use_same_surname') {
            syncSurnames();
        } else if (target.name === 'customer_travelling') {
            syncContact();
        } else if (target.name === 'contact[billing_address_same]') {
            syncBilling();
        } else if (target.matches('[data-book-payment]')) {
            syncPayment();
        }
        if (target === leadTitle) {
            syncContact();
        }
        if (target.matches('.book-field__input, [data-book-terms]') && isFilled(target)) {
            clearError(target);
        }
        syncSubmit();
    });

    form.addEventListener('input', (event) => {
        const target = event.target;
        if (target === leadSurname) {
            syncSurnames();
            syncContact();
        } else if (target === leadFirstName) {
            syncContact();
        }
        if (target.matches('.book-field__input') && isFilled(target)) {
            clearError(target);
        }
        syncSubmit();
    });

    form.addEventListener('submit', (event) => {
        syncSurnames();
        syncContact();
        const invalid = validate();
        if (!invalid.length) {
            return;
        }
        event.preventDefault();
        alertList.replaceChildren(...invalid.map(({message}) => {
            const item = document.createElement('li');
            item.textContent = message;
            return item;
        }));
        alert.hidden = false;
        invalid[0].field.focus();
    });

    form.querySelectorAll('[data-book-address]').forEach((group) => initAddressLookup(group));

    syncSurnames();
    syncContact();
    syncBilling();
    syncPayment();
    syncSubmit();

    if (alert && !alert.hidden) {
        alert.focus();
    }

    function checkedValue(name) {
        return form.querySelector(`input[name="${name}"]:checked`)?.value;
    }

    function requiredFields() {
        return [...form.querySelectorAll('[required]')].filter((field) => !field.closest('[hidden]'));
    }

    function isComplete() {
        return requiredFields().every((field) => !fieldMessage(field));
    }

    function validate() {
        const invalid = [];
        requiredFields().forEach((field) => {
            const message = fieldMessage(field);
            if (message) {
                showError(field, message);
                invalid.push({field, message});
            } else {
                clearError(field);
            }
        });
        return invalid;
    }

    function fieldMessage(field) {
        if (field === terms) {
            return field.checked ? '' : 'You must agree to the terms and conditions.';
        }
        const label = form.querySelector(`label[for="${field.id}"]`)?.firstChild?.textContent.trim().toLowerCase() || 'this field';
        const owner = fieldOwner(field);
        if (!isFilled(field)) {
            if (field.tagName === 'SELECT') {
                return owner ? `Please select a ${label} for ${owner}.` : `Please select a ${label}.`;
            }
            if (field.closest('[data-book-billing]')) {
                return `Please enter the billing ${label}.`;
            }
            return owner ? `Please enter the ${label} for ${owner}.` : `Please enter your ${label}.`;
        }
        if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim())) {
            return 'Please enter a valid email address.';
        }
        return '';
    }

    // "Adult 1", or "Room 2, Adult 1" when the booking has more than one room.
    function fieldOwner(field) {
        const passenger = field.closest('.book-passenger')?.querySelector('.book-passenger__label')?.textContent.trim();
        if (!passenger) {
            return '';
        }
        const room = form.querySelectorAll('.book-room').length > 1
            ? field.closest('.book-room')?.querySelector('.book-room__head span')?.textContent.trim()
            : '';
        return room ? `${room}, ${passenger}` : passenger;
    }
}

function isFilled(field) {
    return field.type === 'checkbox' ? field.checked : field.value.trim() !== '';
}

function errorElement(field) {
    return document.getElementById(`${field.id}-error`);
}

function showError(field, message) {
    const error = errorElement(field);
    field.setAttribute('aria-invalid', 'true');
    if (error) {
        error.textContent = message;
        error.hidden = false;
        field.setAttribute('aria-describedby', error.id);
    }
}

function clearError(field) {
    const error = errorElement(field);
    field.removeAttribute('aria-invalid');
    if (error && field.getAttribute('aria-describedby') === error.id) {
        field.removeAttribute('aria-describedby');
    }
    if (error) {
        error.hidden = true;
        error.textContent = '';
    }
}

// Postcode lookup through /api/address: lists the matches, then fills the address fields from the chosen one.
function initAddressLookup(group) {
    const postcode = group.querySelector('[data-book-address-field="postcode"]');
    const find = group.querySelector('[data-book-find]');
    const status = group.querySelector('[data-book-status]');
    const results = group.querySelector('[data-book-results]');
    const select = group.querySelector('[data-book-results-select]');

    const setStatus = (text, isError = false) => {
        status.textContent = text;
        status.classList.toggle('is-error', isError);
    };

    find.addEventListener('click', async () => {
        const value = postcode.value.trim();
        results.hidden = true;
        if (value.length < 3) {
            setStatus('Enter a postcode to find your address.', true);
            postcode.focus();
            return;
        }
        find.disabled = true;
        setStatus('Searching for addresses…');
        try {
            const response = await post('/api/address/lookup', {postcode: value});
            const items = response.success ? (response.results || []) : [];
            if (!items.length) {
                setStatus('No addresses found. Please check the postcode or enter the address yourself.', true);
                return;
            }
            const placeholder = new Option(`${items.length} ${items.length === 1 ? 'address' : 'addresses'} found – select yours`, '');
            select.replaceChildren(placeholder, ...items.map((item) => new Option(item.Text || item.Description || 'Address', item.Id)));
            results.hidden = false;
            setStatus(`${items.length} ${items.length === 1 ? 'address' : 'addresses'} found.`);
            select.focus();
        } catch (error) {
            setStatus(error.message || 'An error occurred while looking up the address.', true);
        } finally {
            find.disabled = false;
        }
    });

    select.addEventListener('change', async () => {
        if (!select.value) {
            return;
        }
        setStatus('Loading the address…');
        try {
            const response = await post('/api/address/retrieve', {id: select.value});
            if (!response.success || !response.address) {
                setStatus('Failed to retrieve address details.', true);
                return;
            }
            ['postcode', 'address1', 'address2', 'city'].forEach((name) => {
                const input = group.querySelector(`[data-book-address-field="${name}"]`);
                if (input) {
                    input.value = response.address[name] || '';
                    if (input.value) {
                        clearError(input);
                    }
                }
            });
            results.hidden = true;
            group.dispatchEvent(new Event('input', {bubbles: true}));
            setStatus('Address added. Check the details below.');
            group.querySelector('[data-book-address-field="address1"]')?.focus();
        } catch (error) {
            setStatus(error.message || 'An error occurred while retrieving the address.', true);
        }
    });
}

async function post(url, data) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '',
        },
        body: JSON.stringify(data),
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(body.error || body.message || 'An error occurred while looking up the address.');
    }
    return body;
}
